import React, { useState } from 'react';
import { Button, FormControlLabel, TextField, Typography, Checkbox } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    user_name: '',
    password: ''
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async () => {
    try {
      const res = await axios.post('/api/login', form);

      const { token, role } = res.data;

      // Save token (optional)
      localStorage.setItem('token', token);
      localStorage.setItem('role', role);

      if (role === 'admin') {
        navigate('/admin');
      } else if (role === 'doctor') {
        navigate('/doctor');
      } else {
        navigate('/user');
      }

    } catch (err) {
      alert('Invalid credentials');
    }
  };

  return (
    <div className='login-screen'>
      <div className='loginWrapper'>

        <div className='login-icon'>
          <PersonOutlineOutlinedIcon />
        </div>

        <Typography variant='h4'>Login</Typography>

        <div className='login-form'>
          <TextField
            name="user_name"
            placeholder='Username'
            onChange={handleChange}
            fullWidth
          />

          <TextField
            name="password"
            type='password'
            placeholder='Password'
            onChange={handleChange}
            fullWidth
          />

          <Button variant="contained" onClick={handleLogin}>
            Login
          </Button>
        </div>

        <div className='forgot-password'>
          <FormControlLabel control={<Checkbox />} label="Remember Me" />
        </div>

      </div>
    </div>
  );
};

export default Login;